import SiteContentEditor from "@/project/jain_elibrary-admin/pages/content/SiteContentEditor";

const TermsContent = () => <SiteContentEditor slug="terms" heading="Terms" />;

export default TermsContent;
